import React from 'react';
import { Card, CardContent, Typography, List, ListItemButton, ListItemText, Skeleton, Divider } from '@mui/material';
import PropTypes from 'prop-types';

const RecentOrdersList = ({ orders = [], onView, isLoading }) => (
    <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
        <CardContent>
            <Typography variant="h6" fontWeight={700} mb={2}>
                Recent Orders
            </Typography>

            {isLoading ? (
                [...Array(5)].map((_, i) => <Skeleton key={i} variant="rounded" height={45} sx={{ mb: 1 }} />)
            ) : orders.length > 0 ? (
                <List disablePadding>
                    {orders.map((order, i) => (
                        <React.Fragment key={i}>
                            <ListItemButton onClick={() => onView(order._id)}>
                                <ListItemText
                                    primary={order.code}
                                    secondary={`Customer: ${order.user?.firstName} ${order.user?.lastName}`}
                                />
                            </ListItemButton>
                            {i < orders.length - 1 && <Divider />}
                        </React.Fragment>
                    ))}
                </List>
            ) : (
                <Typography align="center" color="text.secondary">
                    No recent orders found
                </Typography>
            )}
        </CardContent>
    </Card>
);

RecentOrdersList.propTypes = {
    orders: PropTypes.array,
    onView: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
};

export default RecentOrdersList;
